import FlagIcon from '@mui/icons-material/Flag';

const ValidFlagSlugs = new Set([
    "AT",
    "BJ",
    "BW",
    "CN",
    "DO",
    "FK",
    "GG",
    "GY",
    "IO",
    "KM",
    "LS",
    "ML",
    "MY",
    "NZ",
    "PT",
    "SE",
    "SV",
    "TM",
    "UZ",
    "XO",
    "AC",
    "AU",
    "BL",
    "BY",
    "CO",
    "DZ",
    "FM",
    "GH",
    "HK",
    "IQ",
    "KN",
    "LT",
    "MM",
    "MZ",
    "OM",
    "PW",
    "SG",
    "SX",
    "TN",
    "VA",
    "YE",
    "AD",
    "AW",
    "BM",
    "BZ",
    "CR",
    "EC",
    "FO",
    "GI",
    "HM",
    "IR",
    "KP",
    "LU",
    "MN",
    "NA",
    "PA",
    "PY",
    "SH",
    "SY",
    "TO",
    "VC",
    "YT",
    "AE",
    "AX",
    "BN",
    "CA",
    "CU",
    "EE",
    "FR",
    "GL",
    "HN",
    "IS",
    "KR",
    "LV",
    "MO",
    "NC",
    "PE",
    "QA",
    "SI",
    "SZ",
    "TR",
    "VE",
    "ZA",
    "AF",
    "AZ",
    "BO",
    "CC",
    "CV",
    "EG",
    "GA",
    "GM",
    "HR",
    "IT",
    "KW",
    "LY",
    "MP",
    "NE",
    "PF",
    "RE",
    "SJ",
    "TA",
    "TT",
    "VG",
    "ZM",
    "AG",
    "BA",
    "BQ",
    "CD",
    "CW",
    "EH",
    "GB",
    "GN",
    "HT",
    "JE",
    "KY",
    "MA",
    "MQ",
    "NF",
    "PG",
    "RO",
    "SK",
    "TC",
    "TV",
    "VI",
    "ZW",
    "AI",
    "BB",
    "BQ-BO",
    "CF",
    "CX",
    "ER",
    "GBENG",
    "GP",
    "HU",
    "JM",
    "KZ",
    "MC",
    "MR",
    "NG",
    "PH",
    "RS",
    "SL",
    "TD",
    "TW",
    "VN",
    "AL",
    "BD",
    "BQ-SA",
    "CG",
    "CY",
    "ES",
    "GBNIR",
    "GQ",
    "IC",
    "JO",
    "LA",
    "MD",
    "MS",
    "NI",
    "PK",
    "RU",
    "SM",
    "TF",
    "TZ",
    "VU",
    "AM",
    "BE",
    "BQ-SE",
    "CH",
    "CZ",
    "ES-CT",
    "GBSCT",
    "GR",
    "ID",
    "JP",
    "LB",
    "ME",
    "MT",
    "NL",
    "PL",
    "RW",
    "SN",
    "TG",
    "UA",
    "WF",
    "AO",
    "BF",
    "BR",
    "CI",
    "DE",
    "ET",
    "GBWLS",
    "GS",
    "IE",
    "KE",
    "LC",
    "MF",
    "MU",
    "NO",
    "PM",
    "SA",
    "SO",
    "TH",
    "UG",
    "WS",
    "AQ",
    "BG",
    "BS",
    "CK",
    "DJ",
    "EU",
    "GD",
    "GT",
    "IL",
    "KG",
    "LI",
    "MG",
    "MV",
    "NP",
    "PN",
    "SB",
    "SR",
    "TJ",
    "UM",
    "XA",
    "AR",
    "BH",
    "BT",
    "CL",
    "DK",
    "FI",
    "GE",
    "GU",
    "IM",
    "KH",
    "LK",
    "MH",
    "MW",
    "NR",
    "PR",
    "SC",
    "SS",
    "TK",
    "US",
    "XC",
    "AS",
    "BI",
    "BV",
    "CM",
    "DM",
    "FJ",
    "GF",
    "GW",
    "IN",
    "KI",
    "LR",
    "MK",
    "MX",
    "NU",
    "PS",
    "SD",
    "ST",
    "TL",
    "UY",
    "XK"
]);

const RegionIcon: React.FC<{ regionSlug: string, regionSymbol?: string | null, size?: number }> = ({ regionSlug, regionSymbol, size = 16 }) => {

    if (regionSymbol) {
        return <span style={{ fontSize: size * 0.8 }}>{regionSymbol}</span>;
    }

    var upperSlug = regionSlug?.toUpperCase() ?? '';
    if (ValidFlagSlugs.has(upperSlug)) {
        return <img width={size} height={size} alt={regionSlug} onError={(e) => null} src={`/images/flags/${upperSlug}.svg`} />;
    }

    return <FlagIcon sx={{ fontSize: size, color: 'text.disabled' }} />;
}

export default RegionIcon;